/** Calcula el estado de selección de los hijos: all, some o none. */
export function stateOfChildren(submenu: any[]): string {
  const total = (submenu || []).length;
  if (total === 0) return 'none';
  return stateByEnabled(submenu, countEnabled(submenu));
}

/** Cuenta los hijos habilitados. */
function countEnabled(submenu: any[]): number {
  let count = 0;
  for (const sub of submenu) count = addEnabled(count, sub);
  return count;
}

/** Suma uno cuando el hijo está habilitado. */
function addEnabled(count: number, sub: any): number {
  if (sub.enabled) return count + 1;
  return count;
}

/** Resuelve el estado según habilitados y total. */
function stateByEnabled(submenu: any[], enabled: number): string {
  if (enabled === 0) return 'none';
  if (enabled === submenu.length) return 'all';
  return 'some';
}

/** Arma el payload bulk con padre e hijos. */
export function buildBulkItems(roleId: string, menu: any, enabled: boolean): any[] {
  const items = [roleItem(roleId, menu.id, enabled)];
  for (const sub of (menu.submenu || [])) items.push(roleItem(roleId, sub.id, enabled));
  return items;
}

/** Arma un item bulk de rol y menú. */
function roleItem(roleId: string, menuId: string, enabled: boolean): any {
  return { roleId, menuId, enabled };
}

/** Aplica el valor a todos los hijos en memoria. */
export function setChildrenEnabled(submenu: any[], enabled: boolean): void {
  for (const sub of (submenu || [])) sub.enabled = enabled;
}
